import React from "react";
import FadeIn from "./FadeIn";
import SectionHeader from "./SectionHeader";

const LogoGrid = ({ title, logos }) => (
  <div className="mb-16 last:mb-0">
    {title && (
      <FadeIn>
        <h3 className="font-display text-2xl font-bold text-ku-royal mb-8 text-center">
          {title}
        </h3>
      </FadeIn>
    )}
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
      {logos.map((logo, i) => (
        <FadeIn key={logo.name + i} delay={i * 0.03}>
          <div className="ku-card p-6 flex flex-col items-center justify-between text-center h-full hover:scale-[1.02] transition-transform">
            {/* Fix: Remove fixed width, use max-h to constrain height, object-contain stays */}
            <div className="h-20 flex items-center justify-center mb-4">
              <img 
                src={logo.src} 
                alt={logo.name} 
                className="max-h-full w-auto object-contain" 
              />
            </div>
            <p className="font-accent text-sm font-medium text-gray-700">{logo.name}</p>
          </div>
        </FadeIn>
      ))}
    </div>
  </div>
);

export default LogoGrid;
